<script>
  import KeyItem from "./KeyItem.svelte";
  import { windowWidth, keyIsExpanded } from "../../stores/global.js";

  let notClickedYet = true;

  const toggle = function () {
    keyIsExpanded.set(!$keyIsExpanded);
    notClickedYet = false;
  };

  $: keyHeight = $windowWidth > 450 ? 450 : 550;
  $: keyTitleHeight = 40;

  const keyItems = [
    {
      title: "Mission-driven company",
      description:
        "Game-changing businesses that push the world forward and establish new paradigms for doing well by doing good",
    },
    {
      title: "Policy & government",
      description:
        "When laws, norms, and leadership inspire and reflect the changing global mood around the role of business in public life",
    },
    {
      title: "Impact investment",
      description:
        "Key moments in public markets that signal the steady march of socially responsible thinking into the practice of mainstream finance",
    },
    {
      title: "Nonprofits & institutions",
      description:
        "How influential nonprofits and other institutions with ties to business set the moral tone for building a more equitable, sustainable future",
    },
  ];
</script>

<div
  id="mobileKey"
  class="key  {notClickedYet ? 'unclicked' : 'clicked'}"
  style="width: {$windowWidth}px;"
>
  <div class="key-flex-container">
    <div
      class="grid"
      style="grid-template-columns: {$windowWidth}px;
        max-height: {$keyIsExpanded == true
        ? keyHeight + 'px'
        : keyTitleHeight + 'px'}"
    >
      <div
        class="key-title {$keyIsExpanded == true ? 'expanded' : 'closed'}"
        style="height: {keyTitleHeight}px; width: {$windowWidth}px;"
        on:click={toggle}
      >
        <h1>Key</h1>
      </div>
      {#if $keyIsExpanded == true}
        {#each keyItems as item}
          <KeyItem {item} mobile={true} />
        {/each}
      {/if}
    </div>
  </div>
</div>

<style>
  .key {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 100;
    right: 100%;
    transform: translateX(100%);
    overflow: hidden;
    box-shadow: 1px 1px 10px #1e1e1e80;
  }

  .key-flex-container {
    width: 100%;
    display: flex;
  }

  .grid {
    /* background-color: rgb(35, 35, 75); */
    background: linear-gradient(to bottom, #444d7d 50%, black 300%);
    display: grid;
    transition: all 400ms ease;
    border-radius: 5px 0 0 0;
    padding-bottom: 6px;
    width: 100%;
  }

  .key-title {
    /* transition: 300ms all ease; */
    grid-column-start: 1;
    grid-column-end: 1;
    grid-row-start: 1;
    grid-row-end: 3;
    display: flex;
    place-items: center;
    justify-content: center;
    border-radius: 5px 0 0 0;
    cursor: pointer;
    padding: 10px;
    text-transform: uppercase;
    background: #444d7d;
    font-size: 0.7rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
  /* 
  .key.unclicked {
    animation: nudgeUp 3000ms ease-in-out infinite;
  }

  @keyframes nudgeUp {
    0% {
      transform: translateX(100%) translateY(0);
    }

    30% {
      transform: translateX(100%) translateY(-10px);
    }

    100% {
      transform: translateX(100%) translateX(0);
    }
  } */
</style>
